import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl} from '@angular/forms';
import {Location} from '@angular/common';
import { BaseService } from '../../services/base.services';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import pageSettings from '../../config/page-settings';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.html',
  styleUrls: ['./change-password.css']
})
export class ChangePasswordPage implements OnInit {
  form: FormGroup;
  isLoading: boolean;
  ClaveNueva: any;
  ClaveNuevaRepeat: any;
  ClaveActual: any;
  pageSettings = pageSettings;
  currentPasswordForm = new FormControl('', [Validators.required]);

  newPasswordForm = new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]);

  newPasswordRepeatForm = new FormControl('', [
    Validators.required,
    Validators.compose([this.validatorCustomRepeatPassword()])
  ]);

  constructor(
    private baseService: BaseService,
    private router: Router,
    private toastr: ToastrService,
    _formBuilder: FormBuilder,
    private _location: Location
  ) {
    this.pageSettings.pageEmpty = false;
    this.pageSettings.pageWithoutSidebar = true;
    this.pageSettings.appSelected = null;
  }
  backClicked() {
    this._location.back();
  }

  ngOnInit() {}
  ngOnDestroy() {
    this.pageSettings.pageTopMenu = false;
    this.pageSettings.pageWithoutSidebar = false;
  }

  validatorCustomRepeatPassword() {
    return (control: AbstractControl): { [s: string]: boolean } => {
      if (this.newPasswordForm.value !== control.value) {
        return { required: true };
      }
    };
  }

  getErrorMessage(context: string) {
    switch (context) {
      case 'currentPassword':
        return this.currentPasswordForm.hasError('required') ? 'La clave actual es requerida.' : '';
      case 'newPassword':
        return this.newPasswordForm.hasError('required')
          ? 'La nueva clave es requerida.'
          : 'La clave debe contener al menos 6 caracteres.';
      case 'newRepeatPassword':
        return this.newPasswordRepeatForm.hasError('required')
          ? 'Debe repetir la nueva clave'
          : 'No coincide con la nueva clave. ';
    }
  }

  savePassword() {
    if (!this.ClaveActual || !this.ClaveNueva || !this.ClaveNuevaRepeat) {
      this.toastr.error('Ingrese todos los campos', '');
      return;
    }
    
    if (this.ClaveNueva !== this.ClaveNuevaRepeat) {
      this.toastr.error('La clave repetida no coincide', '');
      return;
    } 
    
    var _storage = JSON.parse(localStorage.getItem('admin'));
    this.baseService.set_NuevaClave({ idUsuario: _storage.usuario.IDUSUARIO, oldPass: this.ClaveActual, newPass: this.ClaveNueva}).subscribe(
      (result: any) => {
        if(result.Resp == "true") {
          this.toastr.success('Tu contraseña ha sido modificada correctamente', 'Acción Realizada');
          this._location.back();
        }else{
          this.toastr.error('Su contraseña actual no coincide', '');
        }


      },
      error => {
        console.log(error);
        this.toastr.error(error.error.error, 'Alerta!');
      }
    );
  }
}
